<div class="d-flex flex-column">
    <span class="mt-2 mx-auto text-center">{{'information.title' | translate}}</span>
    <span [innerHTML]="'information.html' | translate" class="mt-4 small"></span>
    <button [routerLink]="['..']" class="mt-2 btn btn-outline-secondary mx-auto col-4">
        {{'general.back' | translate}}
    </button>
</div>
